<template>
  <ul v-if="content.children.length">
    <li
      class="flex-box"
      v-for="(obj, index) of content.children"
    >
      <span class="forth-index">.{{ index + 1 }}</span>
      {{ obj.header[0].content }}
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    content: Object,
    parentIndexes: Array,
  },
}
</script>
<style lang="scss" scoped>
@import '../TermsOfUse.scss';
</style>
